import React, { useState, useEffect } from "react";
import "../assets/css/component-alert-new-participant-in-meeting.css";
import { MdOutlineClose } from "react-icons/md";

export default function AlertNewParticipant({
  peer,
  message,
  setNouveauParticipant,
  exit,
}) {
  const [imageLoaded, setImageLoaded] = useState(false); // Etat pour vérifier si l'image est chargée
  const [imageError, setImageError] = useState(false); // Etat pour vérifier si l'image a échoué à se charger

  useEffect(() => {
    setTimeout(function () {
      setNouveauParticipant(null);
    }, 3300);
  }, []);

  // Handler appelé quand l'image est correctement chargée
  const handleImageLoad = () => {
    setImageLoaded(true); // L'image est bien chargée
  };

  // Handler appelé quand l'image échoue à se charger
  const handleImageError = () => {
    setImageError(true); // L'image n'a pas pu être chargée
  };

  return (
    <>
      <div className="animate__animated animate__backInUp animate__fast alert__new__participant__joining__meeting__card">
        <div className="alert__new__participant__joining__meeting__icon-container">
          {peer.image && !imageError ? (
            <img
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
              }}
              src={peer.image}
              alt="new_peer"
              onLoad={handleImageLoad} // Déclenchement quand l'image se charge
              onError={handleImageError} // Déclenchement quand l'image échoue à se charger
            />
          ) : (
            !imageLoaded && (
              <div
                className={`text-uppercase tyn-media img`}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  cursor: "pointer",
                  backgroundColor: peer.colors.background,
                  color: peer.colors.text,
                }}
              >
                {peer.prenom.charAt(0) + peer.nom.charAt(0)}
              </div>
            )
          )}
        </div>
        <div className="alert__new__participant__joining__meeting__message-text-container">
          <p
            className="alert__new__participant__joining__meeting__message-text"
            style={{
              color: exit ? "#ff4343" : "#124fff",
            }}
          >
            {exit ? "Participant en moins" : "Nouveau participant"}
          </p>
          <p className="alert__new__participant__joining__meeting__sub-text">
            {message}
          </p>
        </div>
        <button
          className="border-none"
          style={redCircle}
          onClick={() => setNouveauParticipant(null)}
        >
          <MdOutlineClose
            style={{
              fontSize: "50px",
            }}
          />
        </button>
      </div>
    </>
  );
}

const redCircle = {
  height: "25px",
  width: "25px",
  borderRadius: "50%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  textAlign: "center",
  backgroundColor: "#ff4343",
  color: "#fff",
};
